import axios from 'axios'

const DashboardService = {
  async getStatistics (params = {}) {
    return axios.get('scm/dashboard', { params })
  }
}

export default DashboardService
